import store from '../store'
import FN from '../utility/fn'
import PS from 'pubsub-js'
import { thirdReport, adReport } from '../utility/thirdSdk.js';


function getRoleBaseMsg(arg) {
  FN.saveSession('ROLE_INFO', arg)
  FN.saveLocal('ROLE_INFO', arg)
  return {
    server_id: arg.serverId,
    server_name: arg.serverName,
    role_id: arg.roleId,
    role_name: arg.roleName,
    role_level: arg.roleLevel,
    balance: arg.userMoney,
    vip_level: arg.vipLevel,
    spare: arg.transformLevel !== undefined ? JSON.stringify({ "transform_level": arg.transformLevel }) : JSON.stringify({ "transform_level": 0 })
  }
}

function checkPWA() {
  const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || document.referrer.includes('android-app://')
  // console.log('isInStandaloneMode: ', Boolean(isInStandaloneMode))
  return Boolean(isInStandaloneMode)
}
// 点击pwa安装
function handleClickInstall(callback) {
  // console.log('click', window.deferredPrompt)
  if (FN.isIOS && FN.isSafari && window.navigator.standalone != undefined && !window.navigator.standalone) {
    // 显示ios安装提示
    store.commit('UPDATE_IOS_GUIDE', true)
    callback({
      statusCode: 0,
      status: '成功'
    })
  } else if (window.deferredPrompt) {
    // 触发安装提示
    window.deferredPrompt.prompt();
    // 等待用户选择是否安装
    window.deferredPrompt.userChoice.then((userChoiceResult) => {
      // accepted 安装,  dismissed 取消安装
      if (userChoiceResult.outcome === 'dismissed') {
        // console.log('用户取消安装');
        callback({
          statusCode: 1,
          status: '用户取消安装'
        })
      } else {
        // console.log('用户安装到桌面');
        callback({
          statusCode: 0,
          status: '安装成功'
        })
      }
      // 在用户选择后，清除提示
      window.deferredPrompt = null;
    })
  } else {
    callback({
      statusCode: 1,
      status: '异常'
    })
  }
  
}

// 用于转化响应给cp的融合登录参数
const transform = data => {
  let {
    statusCode,
    loginParams
  } = data
  if (!loginParams) return data
  const installType = localStorage.getItem('supportStand')
  // console.log('supportStand------------', installType)
  // return data
  let FUSE_USER_INFO = FN.getSession('FUSE_USER_INFO')
  let cpRes = {
    statusCode,
    loginParams: {
      statusCode,
      user_id: FUSE_USER_INFO.user_id,
      platformChanleId: Number(FN.getSession('FUSE_CHANNEL_INFO').channel_id),
      userName: loginParams.userName || '',
      time: String(FUSE_USER_INFO.timestamp),
      new_sign: FUSE_USER_INFO.new_sign,
      guid: FUSE_USER_INFO.guid, // TODO
      cp_ext: FUSE_USER_INFO.cp_ext || '',
      ext: FUSE_USER_INFO.ext || '',
      wxinfo: loginParams.wxinfo || '',
      isInStandaloneMode: checkPWA(),
      supportInstall: !installType ? 0 : Number(installType),
    }
  }
  return cpRes
}

// 第三方上报登录
function loginSuccess(userId) {
  window.MJFUSESDK.getBuryingConfig().then(res => {
    if (res.code === 0 && res.data) {
      const loginDates = JSON.parse(localStorage.getItem(`LOGIN_DATES_${window.FUSE_CHANNEL_INFO.pf_game_id}_${userId}`)) || []
      const cur = new Date().toLocaleDateString()
      const buryingConfig = res.data.cfg
      FN.saveSession('buryingConfig', buryingConfig)
      // 判断当天是否登录过
      if (!loginDates.includes(cur) && buryingConfig.login) {
        const loginBuryingConfig = buryingConfig.login.config || []
        loginBuryingConfig.sort((a,b) => a.value - b.value)
        // 设置最大保存的登录天数，避免缓存的登录天数无限大
        const max = loginBuryingConfig[loginBuryingConfig.length - 1].value * 1 + 2
        loginDates.push(cur)
        FN.saveLocal(`LOGIN_DATES_${window.FUSE_CHANNEL_INFO.pf_game_id}_${userId}`, loginDates.slice(-max))
        // 判断是否符号埋点条件
        const buryingItem = loginBuryingConfig.filter(item => Number(item.value) === loginDates.length)[0]
        if (buryingItem) {
          // 触发登录埋点
          thirdReport(buryingItem)
        }
      }
    }
  })
}
// 第三方上报角色升级
function roleLevelUpdate(lv) {
  const buryingConfig = FN.getSession('buryingConfig')
  // 判断是否存在等级埋点上报配置
  if (buryingConfig && buryingConfig.level_list) {
    const buryingItem = buryingConfig.level_list.filter(item => Number(item.value) === Number(lv))[0]
    if (buryingItem) {
      // 触发角色升级
      thirdReport(buryingItem)
    }
  }
}
// 安装pwa上报
function pwaReport(type) {
  if (type === 'install') {
    // pwa安装
    adReport('CustomizeProduct')
  } else {
    // pwa进入游戏触发上报，同设备仅上报一次
    const cacheKey = 'pwa_login_report_' + FN.getSession('FUSE_CHANNEL_INFO').app_id
    const PWALogin = localStorage.getItem(cacheKey)
    if (!PWALogin) {
      localStorage.setItem(cacheKey, 'pwa')
      thirdReport({key: 'pwa_enter', value: 'login'})
    }
  }
}

const JSSDK = {
  init(token, params) {
    // if (params.dubug === true) {
    //   FN.inject('head', '/vconsole/vconsole.min.js' + `?_cache=${new Date().valueOf()}`, 'script');
    // }
    // 为客户端订阅事件
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    store.dispatch('SET_SDK_COMPONENT_MESSAGE', {
      interfaceName: 'init',
      token,
      params
    })
  },
  // 登录
  login(token, params) {
    // 为客户端订阅事件
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    if (FN.getURLparams().app !== true) {
      // 调起大千文化渠道
      store.dispatch('SET_SDK_COMPONENT_MESSAGE', {
        interfaceName: 'login',
        token,
        params
      })
    }
    // 融合渠道sdk.use.js
    window.FUSESDKAPI.login({
      token,
      data: {
        loginWay: 'default'
      },
      callback(data = {}) {
        const cbData = transform(data)
        PS.publish(token, cbData)
        loginSuccess(cbData.loginParams.user_id)
        if (checkPWA()) {
          pwaReport('login')
        }
      }
    })
  },
  // 切换账号
  changeAccount(token, params) {
    // 为客户端订阅事件
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: FN.wrap(data)
      })
    })
    window.FUSESDKAPI.changeAccount({
      token,
      data: params,
      callback(data = {}) {
        PS.publish(token, data)
        if (FN.getURLparams().app !== true) {
          store.dispatch('SET_SDK_COMPONENT_FLOATBALL', '')
        }
      }
    })
  },
  // 充值
  recharge(token, params) {
    // 为客户端订阅事件
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    // 获取渠道充值参数
    let ext = window.FUSESDKAPI.getEXT ? window.FUSESDKAPI.getEXT(params) : {}
    // 获取融合下单,cp传过来的参数
    let fuseParams = {
      user_id: FN.getSession('FUSE_USER_INFO').user_id,
      ...getRoleBaseMsg(params),
      amount: params.amount, // 必填充值金额 单位：分
      notify_url: params.callbackURL, // 必填 CP通知URL
      callback_info: params.callbackInfo, // cP回调参数
      cp_product_id: params.cpProductId,
      charge_mount: params.chargeMount, // 金钱数量/道具数量
      ext: JSON.stringify(ext)
    }

    // 融合下单
    window.MJFUSESDK.makeOrder({
      ...fuseParams
    }).then(res => {
      if (res.code === 0) {
        const payInfo = {
          ...params,
          ...res.data,
          fuseParams
        }
        if (FN.getURLparams().app !== true) {
          // store.dispatch('SET_SDK_COMPONENT_MESSAGE', data)
          // 大千IOS渠道
          if (FN.getSession('FUSE_CHANNEL_INFO').channel === 'applemjh5') {
            if (res.data.cut_pay) {
              // 切支付(大千渠道支付)
              store.dispatch('SET_SDK_COMPONENT_MESSAGE', {
                interfaceName: 'recharge'
              })
            } else {
              // 因为这个 store.dispatch('SET_SDK_COMPONENT_MESSAGE', '') 作用是避免,取消支付,组件没有清除,不起苹果支付
              store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
              setTimeout(function () {
                store.dispatch('SET_SDK_COMPONENT_MESSAGE', 'AppleRecharge')
              }, 10)
            }
          } else {
            store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
            setTimeout(function () {
              // 判断兼容蜜蜂过包 ios的支付跳转，使用个人中心的那套支付
              store.dispatch('SET_SDK_COMPONENT_MESSAGE', {
                interfaceName: 'rechargeIframe'
              })
              return false

            }, 10)
          }
          
          // 存支付参数到vuex中,便于拉起大千支付列表调用
          store.dispatch('GET_SDK_RECHARGE_AGES', payInfo)
        }
        // const money = Number((fuseParams.amount/100).toFixed(2))
        // 上报下单成功
        adReport('AddToWishlist', {
          currency: 'USD',
          value: Number((fuseParams.amount/100).toFixed(2)),
          contents: payInfo.cp_product_id,
        })
        // // 更新埋点配置 累充次数累充金额
        // window.MJFUSESDK.getBuryingConfig().then(buryingRes => {
        //   if (buryingRes.code === 0 && buryingRes.data) {
        //     buryingConfig = buryingRes.data.cfg
        //     rechargeUpdate(fuseParams.cp_product_id, money)
        //   }
        // })
        window.FUSESDKAPI.recharge({
          token,
          data: payInfo,
          callback(data = {}) {
            PS.publish(token, data)
          }
        })
      }
    })
  },
  // 创建角色数据上报
  createRole(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let asg = {
      user_id: FN.getSession('FUSE_USER_INFO').user_id,
      ...getRoleBaseMsg(params)
    }
    window.MJFUSESDK.roleAdd(asg).then(data => {
      PS.publish(token, data)
    })
    // 上报注册 按设备
    const CompleteRegistration = localStorage.getItem('FB_CompleteRegistration')
    if (!CompleteRegistration) {
      localStorage.setItem('FB_CompleteRegistration', 1)
      adReport('CompleteRegistration')
    }
    // 上报角色
    roleLevelUpdate(asg.role_level)

    if (typeof window.FUSESDKAPI.createRole === 'function') {
      window.FUSESDKAPI.createRole({
        token,
        data: params,
        callback: () => { }
      })
    }
  },
  // 角色登录数据上报
  changeRole(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let args = {
      user_id: FN.getSession('FUSE_USER_INFO').user_id,
      ...getRoleBaseMsg(params)
    }

    window.MJFUSESDK.roleLogin(args).then(data => {
      PS.publish(token, data)
    })
    if (FN.getURLparams().app !== true) {
      store.dispatch('SET_SDK_COMPONENT_FLOATBALL', 'floatBall')
    }
    if (typeof window.FUSESDKAPI.changeRole === 'function') {
      window.FUSESDKAPI.changeRole({
        token,
        data: params,
        callback: () => { }
      })
    }
  },
  // 角色升级数据上报
  upgradeRole(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: FN.wrap(data)
      })
    })
    let asg = {
      user_id: FN.getSession('FUSE_USER_INFO').user_id,
      ...getRoleBaseMsg(params)
    }
    window.MJFUSESDK.roleLevel(asg).then(data => {
      PS.publish(token, data)
    })

    // 上报角色
    roleLevelUpdate(asg.role_level)

    if (typeof window.FUSESDKAPI.upgradeRole === 'function') {
      window.FUSESDKAPI.upgradeRole({
        token,
        data: params,
        callback: () => { }
      })
    }
  },
  // 选择服务器数据上报
  slectServe(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: FN.wrap(data)
      })
    })
    if (typeof window.FUSESDKAPI.slectServe === 'function') {
      window.FUSESDKAPI.slectServe({
        token,
        data: params,
        callback: data => {
          PS.publish(token, data)
        }
      })
    } else {
      let res = {
        statusCode: 1,
        status: '暂时不提供该方法'
      }
      PS.publish(token, res)
    }
  },
  // 结束任务数据上报
  task(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: FN.wrap(data)
      })
    })
    if (typeof window.FUSESDKAPI.task === 'function') {
      window.FUSESDKAPI.task({
        token,
        data: params,
        callback: data => {
          PS.publish(token, data)
        }
      })
    } else {
      let res = {
        statusCode: 1,
        status: '暂时不提供该方法'
      }
      PS.publish(token, res)
    }
  },
  // 获得荣誉数据上报
  honor(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: FN.wrap(data)
      })
    })
    if (typeof window.FUSESDKAPI.task === 'function') {
      window.FUSESDKAPI.honor({
        token,
        data: params,
        callback: data => {
          PS.publish(token, data)
        }
      })
    } else {
      let res = {
        statusCode: 1,
        status: '暂时不提供该方法'
      }
      PS.publish(token, res)
    }
  },
  // 获取当前用户 id
  getUserID(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let userID = {
      uid: FN.getSession('FUSE_USER_INFO').user_id
    }
    PS.publish(token, userID)
  },
  // 获取游戏接入平台 id
  getPTID(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let PTID = {
      channelId: FN.getSession('FUSE_CHANNEL_INFO').channel_id
    }
    PS.publish(token, PTID)
  },
  // 获取渠道分发 id
  getFromID(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let FromID = {
      fromId: FN.getSession('FUSE_CHANNEL_INFO').package_id
    }
    PS.publish(token, FromID)
  },
  // 查询实名认证
  checkRealNameAuth(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    let age = {
      statusCode: 0,
      status: { age: FN.getSession('USER_INFO').age || 0 }
    }
    PS.publish(token, age)
  },
  // 检查用户是否绑定手机
  checkBindPhone(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    window.MJFUSESDK.checkBindPhone({
      guid: FN.getSession('FUSE_USER_INFO').guid
    }).then(data => {
      let res = {
        statusCode: data.data.status,
        status: data.msg
      }
      PS.publish({
        token,
        res
      })
    })
  },
  flymeChangeAccount(token, args) {
    FN.log('EVENT:flymeChangeAccount', { token, args })
    if (!window.FUSESDKAPI.flymeChangeAccount) {
      FN.log('没有flymeChangeAccount方法')
      return false
    } else {
      FN.log('有flymeChangeAccount方法')
      window.FUSESDKAPI.flymeChangeAccount({
        token,
        data: {
          // TODO
          loginWay: ''
        },
        callback: (data = {}) => {
          PS.publish(token, data)
        }
      })

      PS.subscribeOnce(token, async (msg, data) => {
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        PS.publish('H5.flymeChangeAccount', data)
      })
    }
  },
  // sdk实名认证
  flymeCheckRealNameAuth(token, args) {
    FN.log('EVENT:flymeCheckRealNameAuth', { token, args })
    if (!window.FUSESDKAPI.flymeCheckRealNameAuth) {
      FN.log('没有flymeCheckRealNameAuth方法')
      return false
    } else {
      FN.log('有flymeCheckRealNameAuth方法')
      window.FUSESDKAPI.flymeCheckRealNameAuth({
        token,
        data: {
          // TODO
          loginWay: ''
        },
        callback: (data = {}) => {
          PS.publish(token, data)
        }
      })

      PS.subscribeOnce(token, async (msg, data) => {
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        PS.publish('H5.flymeCheckRealNameAuth', data)
      })
    }
  },
  share(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    if (typeof window.FUSESDKAPI.share === 'function') {
      window.FUSESDKAPI.share({
        token,
        data1: params,
        callback: (data = {}) => {
          PS.publish(token, data)
        }
      })
    }
  },
  kefu(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    if (FN.getURLparams().app !== true) {
      store.dispatch('SET_SDK_COMPONENT_KEFU', 'kefu')
    }
    if (typeof window.FUSESDKAPI.kefu === 'function') {
      window.FUSESDKAPI.kefu({
        token,
        data: params,
        callback: (data = {}) => {
          PS.publish(token, data)
        }
      })
    } else {
      PS.publish(token, {
        statusCode: 0,
        status: '暂未提供'
      })
    }
  },
  // 获取角色信息
  getRoleList(token, params) {
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    window.MJFUSESDK.getRoleList().then(data => {
      console.log('getRoleList', data)
      let res = {
        statusCode: data.data.status,
        status: data.msg
      }
      PS.publish({
        token,
        res
      })
    })
  },
  // 测试强更接口
  // spread(token, params) {
  //   PS.subscribe(token, async (msg, data) => {
  //     FN.post({
  //       token,
  //       payload: data
  //     })
  //   })
  //   window.MJFUSESDK.spread().then(data => {
  //     // console.log(data)
  //     // let res = {
  //     //   statusCode: data.data.status,
  //     //   status: data.msg
  //     // }
  //     // PS.publish({
  //     //   token,
  //     //   res
  //     // })
  //   })
  // }

  getDeviceInfo(token, params) {
    FN.post({
      token,
      payload: {}
    })
  },
  webInstall(token, params) {
    // console.log('webInstall', params)
    PS.subscribe(token, async (msg, data) => {
      FN.post({
        token,
        payload: data
      })
    })
    handleClickInstall((data) => {
      if (data.statusCode === 0) {
        pwaReport('install')
      }
      PS.publish(token, data)
    })
  },
}
export {
  JSSDK
}
